import type { ThemeName } from '@bn-games/theming';
import { pageLanguage, type Language } from '@bn-games/i18n-core';

export type Difficulty = 'easy' | 'normal' | 'hard' | 'expert';
export type DefaultColor = 'white' | 'black' | 'random';
export type { ThemeName, Language };
export type Variant = 'russian' | 'english';

export interface Settings {
  readonly sound: boolean;
  readonly difficulty: Difficulty;
  readonly defaultColor: DefaultColor;
  readonly theme: ThemeName;
  readonly language: Language;
  readonly showValidMoves: boolean;
  readonly playerName: string;
  readonly variant: Variant;
  readonly afkAssistEnabled: boolean;
  readonly afkTimeoutMs: number;
  readonly afkRemindersEnabled: boolean;
  readonly showAfkPingButton: boolean;
  /** Plays a short cue when the turn comes back to me (vs-AI + online only). */
  readonly turnStartSound: boolean;
}

export const DEFAULT_SETTINGS: Settings = {
  sound: true,
  difficulty: 'normal',
  defaultColor: 'white',
  theme: 'mahogany',
  // A /…/ru/ page opens in Russian unless the player already chose a language.
  language: pageLanguage(),
  showValidMoves: true,
  playerName: 'Player',
  variant: 'russian',
  afkAssistEnabled: true,
  afkTimeoutMs: 10_000,
  afkRemindersEnabled: true,
  showAfkPingButton: true,
  turnStartSound: true,
};
